import { BettingOptionsClasses } from 'betgames-contract-js';

export const isOddPickX = (oddsClass: string) =>
    oddsClass?.startsWith(BettingOptionsClasses.PICK_X_PREFIX);
